"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactLabels = ContactLabels;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _ContactLabel = require("./ContactLabel");
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент для выстраивания набора лейблов в Контакте
 * Используется совместно с набором ContactLabel в children
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 * В мобильной версии лейблы выстраиваются вертикально
 */
function ContactLabels(props) {
  const deviceType = (0, _uiKit.useDeviceType)();
  const labels = props.labels.filter(Boolean);
  const isVertical = deviceType === 'phone';
  if (!labels.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['labels'], isVertical && styles['vertical'])
  }, labels.map((label, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: styles['label']
  }, /*#__PURE__*/React.createElement(_ContactLabel.ContactLabel, label))));
}